"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var Rails_1 = require("../../utils/Rails");
var reselect_1 = require("reselect");
var fastMemoize_1 = __importDefault(require("../../utils/fastMemoize"));
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
var reducer_1 = __importDefault(require("./reducer"));
exports.rails = (_a = Rails_1.createRailsSelectors(constants_1.namespace, reducer_1.default), _a.rails), exports.rail = _a.rail, exports.isLoading = _a.isLoading, exports.error = _a.error, exports.railsShallow = _a.railsShallow, exports.continueWatchingRailId = _a.continueWatchingRailId;
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.installedList = reselect_1.createSelector(moduleState, function (state) { return state.installed; });
exports.allApps = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.allApps) === null || _a === void 0 ? void 0 : _a.data; });
exports.getBanner = reselect_1.createSelector(moduleState, function (state) {
    return fastMemoize_1.default(function (appId) {
        var _a, _b;
        return (_b = (_a = state === null || state === void 0 ? void 0 : state.installed) === null || _a === void 0 ? void 0 : _a.find(function (item) { return ramda_1.equals(appId, item === null || item === void 0 ? void 0 : item.packageName); })) === null || _b === void 0 ? void 0 : _b.banner;
    });
});
exports.favouriteList = reselect_1.createSelector(exports.rails, function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.find(function (r) { return ramda_1.equals(r === null || r === void 0 ? void 0 : r.__typename, 'FavouriteAppsGroup'); })) === null || _a === void 0 ? void 0 : _a.contentPage) === null || _b === void 0 ? void 0 : _b.content; });
exports.installedListById = reselect_1.createSelector(moduleState, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.installed) === null || _a === void 0 ? void 0 : _a.reduce(function (r, app) {
        // eslint-disable-next-line no-param-reassign
        r[app === null || app === void 0 ? void 0 : app.packageName] = app;
        return r;
    }, {});
});
exports.isMandatory = reselect_1.createSelector(exports.favouriteList, function (state) { return function (appId) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.find(function (item) { return ramda_1.equals(appId, item === null || item === void 0 ? void 0 : item.id); })) === null || _a === void 0 ? void 0 : _a.mandatory;
}; });
//# sourceMappingURL=selectors.js.map